function isProd() {
    return process.env.NODE_ENV === "production";
}

function asPositiveInteger(value, fallbackValue) {
    const parsedValue = Number.parseInt(value, 10);
    return Number.isFinite(parsedValue) && parsedValue > 0 ? parsedValue : fallbackValue;
}

const recertificationDays = asPositiveInteger(
    isProd() ? '__REACT_APP_RECERTIFICATION_DAYS__' : process.env.REACT_APP_RECERTIFICATION_DAYS,
    90
);
const recertificationRemovalDays = Math.max(
    recertificationDays,
    asPositiveInteger(
        isProd()
            ? '__REACT_APP_RECERTIFICATION_REMOVAL_DAYS__'
            : process.env.REACT_APP_RECERTIFICATION_REMOVAL_DAYS,
        120
    )
);

const envConfig = {
    keycloakUrl: isProd() ? '__REACT_APP_KEYCLOAK_URL__' : process.env.REACT_APP_KEYCLOAK_URL,
    keycloakRealm: isProd() ? '__REACT_APP_KEYCLOAK_REALM__' : process.env.REACT_APP_KEYCLOAK_REALM,
    keycloakClientId: isProd() ? '__REACT_APP_KEYCLOAK_CLIENT_ID__' : process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
    apiBaseUrl: isProd() ? '__REACT_APP_UNLOCK_API_URL__' : process.env.REACT_APP_UNLOCK_API_URL,
    showBanner: String(isProd() ? '__REACT_APP_ANNOUNCEMENT_BANNER__' : process.env.REACT_APP_ANNOUNCEMENT_BANNER).toLowerCase() === 'true',
    hideGroups: String(
        isProd()
            ? '__HIDE_GROUPS__'
            : process.env.HIDE_GROUPS ?? process.env.REACT_APP_HIDE_GROUPS ?? ''
    ),
    recertificationDays,
    recertificationRemovalDays,
}

export default envConfig;
